const notice = () => import('@/page/notice')
const noticeDetail = () => import('@/page/notice/notice-detail')
const noticeList = () => import('@/page/notice/notice-list')
export default [
  {
    path: '/notice',
    name: 'notice',
    component: notice,
    children: [
      {
        path: 'notice-detail',
        name: 'notice-detail',
        component: noticeDetail
      },
      {
        path: 'notice-list',
        name: 'notice-list',
        component: noticeList
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/notice/index.js